import { useCallback } from 'react';
import { QuickFillHooks } from '@frontend/api-quick-fill';
import { useTranslation } from '@frontend/i18n';
import { PanelPortal, PanelHeader } from '@frontend/panel-engine';
import { QuickFillTrayContent, WaitListTrayContent } from '@frontend/quick-fill';
import { ContentLoader, Heading } from '@frontend/design-system';
import { PaddedContent } from '../../layout/padded-content';
import { useTopBarShallowStore } from '../../store/use-top-bar-store';
import { TopBarPanelContent } from '../panels/top-bar-panel-scaffold';

const QuickFillPanel = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation('schedule-quick-fill');
  const { isLoading: isLoadingFF, isWaitlistFFEnabled } = QuickFillHooks.useGetWaitlistFeatureFlagDetails();

  return (
    <PanelPortal enableAnimations id='quickFill' width='medium' onClose={onClose}>
      <PaddedContent css={{ paddingBottom: 0 }}>
        <header css={{ display: 'flex', justifyContent: 'space-between' }}>
          <Heading
            level={2}
            css={{ marginBottom: 0, display: 'flex', gap: 8, alignItems: 'center' }}
            data-testid='tray-header'
          >
            {isLoadingFF ? t('Loading...') : isWaitlistFFEnabled ? t('Waitlist') : t('Quick Fill')}
          </Heading>
          <PanelHeader.Close iconName='x' size='large' />
        </header>
      </PaddedContent>
      <TopBarPanelContent>
        {isLoadingFF ? (
          <ContentLoader show />
        ) : isWaitlistFFEnabled ? (
          <WaitListTrayContent closeModal={onClose} />
        ) : (
          <QuickFillTrayContent closeModal={onClose} />
        )}
      </TopBarPanelContent>
    </PanelPortal>
  );
};

export const QuickFillPanelWrapper = () => {
  const { isQuickFillOpen, setQuickFillOpen } = useTopBarShallowStore('isQuickFillOpen', 'setQuickFillOpen');
  const closeQuickFill = useCallback(() => setQuickFillOpen(false), [setQuickFillOpen]);

  if (!isQuickFillOpen) {
    return null;
  }
  return <QuickFillPanel onClose={closeQuickFill} />;
};
